import client from "./client";

export const recruitWrite = (locale, data) =>
  client.post(`/api/${locale}/recruit/write`, data);
export const recruitWriteTitle = (locale, studyId) =>
  client.get(`/api/${locale}/recruit/write?studyId=${studyId}`);

// 회원 임상시험모집 등록
export const recruitMemberWrite = (locale, data) =>
  client.post(`/api/${locale}/recruit/writeRegi`, data);
